import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import CompleteCheck from 'resources/Button-Check-selected.png';
import QuestItemImage from '../QuestItem/QuestItemImage';
import './QuestListItem.css';

function renderMissions(missionStatuses) {
  let completedCount = 0;

  const missionList = missionStatuses.map((missionStatus, index) => {
    const mission = missionStatus.mission;
    const isComplete = missionStatus.progress >= missionStatus.goal;
    isComplete && completedCount++;

    return (
      <div key={index} className="mission-details">
        {!isComplete ? (
          <span className="no-icon">{index + 1}.</span>
        ) : (
          <img
            className="completed-icon"
            src={CompleteCheck}
            alt="Green Check"
          />
        )}
        <div className="mission-description">
          {mission.description}:
          <span className="progress-text">{missionStatus.progressText}</span>
        </div>
      </div>
    );
  });

  return (
    <div className="missions-container">
      <div className="tasks-completed">
        {completedCount}/{missionStatuses.length} Tasks Completed
      </div>
      {missionList}
    </div>
  );
}

function renderQuestTime(
  startDateTime,
  endDateTime,
  completionDate,
  abortionDate
) {
  const hasStarted = moment(startDateTime, 'MM/DD/YYYY').isSameOrBefore(
    moment()
  );
  const expired = moment().isAfter(moment(endDateTime, 'MM/DD/YYYY'));

  if (abortionDate) {
    return <div className="quest-time">Aborted: {abortionDate}</div>;
  } else if (completionDate) {
    return <div className="quest-time">Completed: {completionDate}</div>;
  } else if (expired) {
    return <div className="quest-time">Expired: {endDateTime}</div>;
  } else if (hasStarted) {
    return <div className="quest-time">Complete by: {endDateTime}</div>;
  } else {
    return (
      <div className="quest-time">
        Runs from: {startDateTime} - {endDateTime}
      </div>
    );
  }
}

function QuestListItem({
  startDateTime,
  endDateTime,
  completionDate,
  abortionDate,
  quest,
  missionStatuses
}) {
  const questName = quest.prizeDetails ? quest.prizeDetails.name : 'N/A';

  return (
    <div className="quest-list-item">
      <QuestItemImage quest={quest} />
      <div className="quest-item-details">
        <div className="title">{questName}</div>
        {renderMissions(missionStatuses)}
        {renderQuestTime(
          startDateTime,
          endDateTime,
          completionDate,
          abortionDate
        )}
      </div>
    </div>
  );
}

QuestListItem.propTypes = {
  endDateTime: PropTypes.string,
  completionDate: PropTypes.string,
  quest: PropTypes.shape({
    id: PropTypes.string,
    prizeDetails: PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      description: PropTypes.string
    }),
    prizes: PropTypes.shape({
      prizes: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          category: PropTypes.string
        })
      )
    })
  }),
  missionStatus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      goal: PropTypes.number,
      progress: PropTypes.number,
      progressText: PropTypes.string,
      mission: PropTypes.shape({
        description: PropTypes.string,
        icons: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
            alt: PropTypes.string
          })
        )
      })
    })
  )
};

export default QuestListItem;
